var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g, _path59, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _g3, _path66, _path67, _g4, _path68, _path69, _g5, _path70, _path71, _path72, _g6, _path73, _path74, _g7, _path75, _path76, _g8, _path77, _path78, _path79, _g9, _path80, _path81, _g0, _path82, _path83, _path84, _g1, _path85, _path86, _g10, _path87, _path88, _g11, _path89, _path90, _path91, _g12, _path92, _path93, _g13, _path94, _path95, _path96, _path97, _g14, _path98, _path99, _g15, _path100, _path101, _g16, _path102, _path103, _path104, _g17, _path105, _path106, _g18, _path107, _path108, _g19, _path109, _path110, _path111, _g20, _path112, _path113, _g21, _path114, _path115, _path116, _g22, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _g23, _path172, _path173, _path174, _path175, _path176, _g24, _path177, _path178, _path179, _path180, _g25, _path181, _path182, _path183, _path184, _path185, _g26, _path186, _path187, _path188, _g27, _path189, _path190, _path191, _g28, _path192, _path193, _path194, _path195, _g29, _path196, _path197, _path198, _g30, _path199, _path200, _path201, _path202, _path203, _path204, _g31, _path205, _path206, _path207, _g32, _path208, _path209, _path210, _g33, _path211, _path212, _path213, _g34, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _g35, _path226, _path227, _path228, _path229, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworksImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 716,
    viewBox: "0 0 664 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 664,
    height: 716,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6981,
    transform: "translate(-173 -4219)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 548.131H663V547.774H0V548.131ZM552.647 571.122H596.57V570.77H552.647V571.122ZM427.671 575H439.196V574.643H427.671V575ZM525.873 557.857H551.321V557.5H525.873V557.857ZM69.5632 560.262H126.835V559.905H69.5632V560.262ZM138.64 560.262H147.041V559.905H138.64V560.262ZM174.333 566.289H298.547V565.932H174.333V566.289ZM58.23 80.3571C54.2417 80.3571 50.994 83.856 50.994 88.1528V475.905C50.994 480.208 54.2417 483.706 58.23 483.706H314.283C318.271 483.706 321.519 480.208 321.519 475.905V88.1528C321.519 83.856 318.271 80.3571 314.283 80.3571H58.23ZM314.283 484.064H58.23C54.0604 484.064 50.6625 480.403 50.6625 475.905V88.1528C50.6625 83.6551 54.0604 80 58.23 80H314.283C318.452 80 321.85 83.6551 321.85 88.1528V475.905C321.85 480.403 318.452 484.064 314.283 484.064ZM345.04 80.3571C341.051 80.3571 337.804 83.856 337.804 88.1528V475.905C337.804 480.208 341.051 483.706 345.04 483.706H601.092C605.081 483.706 608.328 480.208 608.328 475.905V88.1528C608.328 83.856 605.081 80.3571 601.092 80.3571H345.04ZM601.092 484.064H345.04C340.87 484.064 337.472 480.403 337.472 475.905V88.1528C337.472 83.6551 340.87 80 345.04 80H601.092C605.262 80 608.66 83.6551 608.66 88.1528V475.905C608.66 480.403 605.262 484.064 601.092 484.064Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534 300.349L335.059 325.904L492.401 191.486L456.98 153.092L332.972 323.642L356.548 108H306.457L330.028 323.642L206.02 153.092L170.599 191.486L327.941 325.904L129 300.349V354.651L327.941 329.096L170.599 463.514L206.02 501.908L330.028 331.358L306.457 547H356.548L332.972 331.358L456.98 501.908L492.401 463.514L335.059 329.096L534 354.651V300.349Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.328 163.696L376.837 267.42L483.076 284.056L406.204 364.795L424.352 478.799L329.328 424.972L234.309 478.799L252.451 364.795L175.58 284.056L281.818 267.42L329.328 163.696ZM485.321 167.313L499.706 177.482L515.634 170.477L511.107 188.361L522.213 202.522L505.027 203.407L495.959 219.164L489.868 201.823L473.16 197.405L486.578 185.802L485.321 167.313ZM497.959 440.37L512.344 450.539L528.278 443.534L523.746 461.419L534.852 475.574L517.666 476.464L508.603 492.216L502.507 474.88L485.799 470.456L499.222 458.86L497.959 440.37ZM329.51 519.155L343.894 529.323L359.823 522.318L355.296 540.203L366.397 554.364L349.216 555.249L340.148 571L334.057 553.664L317.349 549.241L330.767 537.644L329.51 519.155ZM127.649 477.943L142.034 488.106L157.962 481.101L153.436 498.985L164.542 513.146L147.356 514.031L138.287 529.788L132.197 512.447L115.489 508.029L128.912 496.427L127.649 477.943ZM100.231 327.407L107.605 332.62L115.769 329.025L113.447 338.192L119.137 345.448L110.334 345.902L105.688 353.976L102.564 345.09L94 342.828L100.881 336.881L100.231 327.407ZM550.094 312.4L557.463 317.614L565.627 314.024L563.309 323.191L569 330.442L560.191 330.895L555.545 338.97L552.422 330.084L543.863 327.821L550.738 321.875L550.094 312.4ZM466.903 352.789L477.058 359.968L488.304 355.024L485.108 367.645L492.944 377.64L480.815 378.267L474.418 389.387L470.115 377.147L458.323 374.028L467.792 365.842L466.903 352.789ZM449.613 515.297L456.988 520.504L465.152 516.915L462.829 526.081L468.519 533.338L459.711 533.786L455.065 541.86L451.947 532.98L443.382 530.712L450.258 524.765L449.613 515.297ZM399.178 489.808L403.881 493.134L409.094 490.844L407.613 496.695L411.245 501.32L405.622 501.612L402.66 506.763L400.665 501.096L395.203 499.646L399.589 495.855L399.178 489.808ZM289.78 483.738L294.488 487.064L299.695 484.774L298.214 490.625L301.847 495.251L296.224 495.542L293.262 500.693L291.266 495.027L285.804 493.576L290.196 489.786L289.78 483.738ZM145.449 259.693L144.227 265.611L148.063 270.046L142.46 270.629L139.732 275.926L137.487 270.365L131.968 269.206L136.183 265.186L135.502 259.172L140.345 262.246L145.449 259.693ZM423.608 140.581L422.392 146.5L426.228 150.935L420.626 151.517L417.892 156.814L415.652 151.254L410.128 150.095L414.343 146.074L413.662 140.061L418.51 143.14L423.608 140.581ZM183.817 383.088L191.191 388.301L199.355 384.712L197.032 393.873L202.723 401.129L193.914 401.583L189.268 409.657L186.15 400.777L177.586 398.509L184.466 392.562L183.817 383.088ZM238.056 536.81L245.425 542.017L253.589 538.428L251.271 547.589L256.957 554.846L248.153 555.299L243.507 563.374L240.389 554.493L231.825 552.225L238.7 546.278L238.056 536.81ZM234.169 200.271L241.538 205.485L249.702 201.895L247.379 211.056L253.075 218.313L244.266 218.766L239.62 226.841L236.497 217.955L227.938 215.692L234.813 209.746L234.169 200.271ZM364.339 156.562L371.708 161.77L379.872 158.18L377.549 167.347L383.24 174.604L374.436 175.057L369.79 183.126L366.667 174.245L358.108 171.977L364.983 166.036L364.339 156.562ZM148.016 154.591L162.401 164.754L178.334 157.755L173.802 175.634L184.908 189.795L167.722 190.68L158.659 206.436L152.568 189.101L135.855 184.677L149.279 173.081L148.016 154.591ZM281.242 121L289.39 126.756L298.412 122.792L295.845 132.921L302.138 140.94L292.404 141.438L287.27 150.364L283.819 140.542L274.356 138.039L281.953 131.471L281.242 121Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M589 596C589 604.836 473.712 612 331.5 612C189.288 612 74 604.836 74 596C74 587.164 189.288 580 331.5 580C473.712 580 589 587.164 589 596Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.361 474L383 447.731L413.644 276L539 302.269L508.361 474Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M466.462 408L443 402.976L447.538 377L471 382.024L466.462 408Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M466.817 394.898C465.765 400.316 460.525 403.864 455.102 402.817C449.684 401.765 446.136 396.52 447.183 391.102C448.235 385.684 453.475 382.136 458.898 383.183C464.321 384.235 467.864 389.475 466.817 394.898Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M427.629 346L405 341.139L409.376 316L432 320.861L427.629 346Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M421 325.853L418.736 337L416.563 336.598L418.477 327.189L416 326.733L416.355 325L421 325.853Z",
    fill: "#263238"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M451.462 350L428 345.462L432.538 322L456 326.538L451.462 350Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M440.622 328.955L438.535 341.431L436.526 340.987L438.29 330.456L436 329.945L436.328 328L440.622 328.955ZM448.98 339.882C448.631 341.984 446.95 343.497 444.046 342.848C442.516 342.506 441.074 341.635 440.226 340.495L441.392 338.892C442.037 339.81 443.13 340.555 444.353 340.825C445.79 341.149 446.763 340.609 446.955 339.45C447.143 338.321 446.555 337.439 444.92 337.072L443.932 336.85L444.197 335.265L447.216 332.443L442.303 331.35L442.63 329.405L450 331.05L449.74 332.599L446.508 335.613C448.496 336.37 449.297 338.009 448.98 339.882Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M476.629 355L454 350.3L458.376 326L481 330.7L476.629 355Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M466.132 343.401L464.151 343.025L463.661 345.524L461.647 345.142L462.137 342.637L456 341.47L456.275 340.048L463.187 334L465.405 334.424L458.88 340.218L462.541 340.918L462.977 338.695L464.926 339.067L464.49 341.29L466.471 341.667L466.132 343.401ZM474.945 344.245C474.584 346.102 472.845 347.439 469.841 346.866C468.258 346.564 466.767 345.794 465.89 344.791L467.096 343.37C467.763 344.181 468.894 344.839 470.159 345.078C471.645 345.364 472.651 344.887 472.851 343.863C473.044 342.871 472.436 342.086 470.74 341.762L469.717 341.566L469.992 340.165L473.12 337.671L468.038 336.706L468.377 334.987L476 336.441L475.731 337.809L472.388 340.473C474.444 341.141 475.273 342.59 474.945 344.245Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3 365L140 360.462L144.7 337L169 341.538L164.3 365Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.474 353.07C153.131 355.09 151.505 356.545 148.696 355.921C147.215 355.592 145.826 354.75 145 353.659L146.128 352.118C146.752 353.001 147.81 353.717 148.993 353.976C150.382 354.282 151.324 353.769 151.51 352.655C151.691 351.57 151.123 350.716 149.542 350.37L148.585 350.156L148.842 348.632L151.762 345.92L147.009 344.87L147.326 343L154.456 344.581L154.204 346.07L151.077 348.967C153.001 349.694 153.776 351.27 153.474 353.07ZM162.215 354.917C161.857 357.024 160.231 358.478 157.421 357.855C155.941 357.526 154.536 356.683 153.726 355.598L154.838 354.046C155.483 354.934 156.54 355.65 157.718 355.91C159.108 356.221 160.05 355.696 160.241 354.571C160.432 353.422 159.914 352.557 157.743 352.078L155.221 351.518L156.857 345.112L163 346.474L162.688 348.344L158.187 347.346L157.497 350.069L158.499 350.289C161.59 350.976 162.572 352.793 162.215 354.917Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.462 369L164 364.462L168.533 341L192 345.538L187.462 369Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.937 351.436C176.128 350.289 175.499 349.213 174.11 348.903C172.896 348.628 171.93 349.237 171.718 350.506C171.507 351.775 172.197 352.758 173.465 353.045C174.724 353.325 175.736 352.635 175.937 351.436ZM177.82 354.168C177.13 358.333 174.653 360.158 171.623 359.473C170.576 359.239 169.619 358.754 169 358.075L170.002 356.537C170.5 357.098 171.16 357.408 171.89 357.572C173.863 358.017 175.343 356.87 175.801 354.109L175.806 354.092C175.036 354.799 173.964 354.992 172.801 354.729C170.737 354.267 169.438 352.465 169.816 350.19C170.218 347.774 172.161 346.628 174.301 347.107C177.155 347.745 178.474 350.26 177.82 354.168ZM185.885 356.192C186.373 353.261 185.613 351.682 184.178 351.36C182.758 351.044 181.545 352.173 181.057 355.109C180.568 358.046 181.329 359.619 182.748 359.935C184.183 360.263 185.396 359.128 185.885 356.192ZM179.099 354.671C179.763 350.676 182.023 348.845 184.505 349.4C187.002 349.962 188.507 352.641 187.843 356.636C187.178 360.631 184.918 362.462 182.421 361.901C179.944 361.345 178.434 358.666 179.099 354.671Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M422.786 372L401 367.3L405.214 343L427 347.7L422.786 372Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M414.704 358.117C414.342 360.291 412.674 361.791 409.791 361.148C408.273 360.809 406.826 359.933 406 358.814L407.142 357.218C407.798 358.135 408.882 358.873 410.096 359.141C411.522 359.463 412.488 358.921 412.684 357.754C412.88 356.575 412.348 355.682 410.122 355.187L407.534 354.61L409.213 348L415.514 349.399L415.194 351.329L410.576 350.299L409.864 353.115L410.897 353.341C414.068 354.05 415.075 355.926 414.704 358.117ZM421 350.626L418.929 363L416.935 362.553L418.686 352.109L416.413 351.603L416.739 349.673L421 350.626Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M446.629 376L424 371.295L428.376 347L451 351.699L446.629 376Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M432.686 357.852C432.491 358.783 433.214 359.527 434.614 359.773C436.025 360.019 437.017 359.584 437.218 358.653C437.424 357.674 436.627 356.952 435.262 356.711C433.897 356.475 432.899 356.873 432.686 357.852ZM436.593 363.441C436.816 362.369 435.939 361.521 434.304 361.233C432.669 360.945 431.539 361.437 431.31 362.51C431.08 363.614 431.929 364.441 433.564 364.729C435.199 365.017 436.357 364.546 436.593 363.441ZM438.807 363.897C438.382 365.917 436.191 366.838 433.226 366.315C430.266 365.791 428.642 364.195 429.067 362.18C429.325 360.982 430.191 360.218 431.528 359.924C430.673 359.275 430.312 358.401 430.53 357.376C430.925 355.512 432.962 354.659 435.595 355.125C438.25 355.596 439.811 357.083 439.415 358.946C439.197 359.972 438.491 360.652 437.419 360.961C438.549 361.693 439.065 362.698 438.807 363.897ZM446 357.124L443.694 368L441.48 367.607L443.424 358.428L440.906 357.983L441.262 356.287L446 357.124Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M471.3 383L447 377.976L451.7 352L476 357.024L471.3 383Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M461.767 371.123L461.46 372.969L454 371.293L454.243 369.832L459.001 366.299C460.165 365.427 460.457 364.776 460.564 364.119C460.744 363.043 460.209 362.279 458.967 362.001C457.983 361.78 457.097 361.979 456.391 362.692L455.271 361.226C456.259 360.172 457.779 359.759 459.439 360.138C461.64 360.631 462.838 362.245 462.493 364.329C462.303 365.472 461.855 366.452 460.199 367.664L457 370.053L461.767 371.123ZM468 362.233L466.042 374L464.163 373.575L465.814 363.643L463.676 363.162L463.978 361.333L468 362.233Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M495.462 387L472 382.3L476.533 358L500 362.7L495.462 387Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.95 368.968L144.707 381.618L142.558 381.162L144.45 370.484L142 369.966L142.346 368L146.95 368.968ZM158 371.3L157.721 372.876L151.253 383L148.948 382.513L155.193 372.773L150.639 371.811L150.26 373.96L148.256 373.54L148.987 369.4L158 371.3Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.3 397L159 391.976L163.7 366L188 371.024L183.3 397Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M172.98 383.683L171.029 383.295L170.541 385.874L168.558 385.475L169.045 382.896L163 381.694L163.276 380.235L170.074 374L172.264 374.437L165.837 380.41L169.443 381.126L169.873 378.842L171.792 379.224L171.363 381.508L173.314 381.902L172.98 383.683ZM183.666 385.814L181.714 385.426L181.227 388L179.243 387.607L179.731 385.027L173.686 383.825L173.956 382.366L180.76 376.131L182.95 376.568L176.523 382.536L180.129 383.257L180.558 380.967L182.478 381.35L182.048 383.639L184 384.027L183.666 385.814Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M418.624 397L396 392.301L400.371 368L423 372.705L418.624 397Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M404.008 379.227C403.849 380.281 404.438 381.122 405.579 381.401C406.73 381.679 407.54 381.187 407.703 380.133C407.872 379.026 407.217 378.209 406.108 377.936C404.995 377.664 404.176 378.12 404.008 379.227ZM407.189 385.552C407.376 384.338 406.66 383.379 405.327 383.053C403.994 382.727 403.072 383.284 402.885 384.498C402.693 385.748 403.39 386.677 404.723 387.009C406.057 387.335 407.002 386.802 407.189 385.552ZM408.999 386.067C408.653 388.353 406.866 389.39 404.447 388.804C402.033 388.211 400.705 386.405 401.056 384.125C401.262 382.769 401.973 381.904 403.063 381.566C402.366 380.832 402.071 379.849 402.244 378.688C402.567 376.58 404.227 375.615 406.379 376.142C408.545 376.675 409.818 378.351 409.495 380.459C409.317 381.62 408.737 382.396 407.867 382.745C408.789 383.574 409.205 384.711 408.999 386.067ZM417.27 387.838C416.938 390 415.427 391.486 412.817 390.853C411.446 390.515 410.136 389.645 409.383 388.531L410.417 386.944C411.015 387.856 411.998 388.59 413.093 388.857C414.384 389.177 415.259 388.638 415.436 387.477C415.614 386.298 415.132 385.416 413.116 384.924L410.772 384.35L412.293 377.77L418 379.168L417.71 381.087L413.528 380.062L412.887 382.863L413.818 383.089C416.69 383.793 417.602 385.659 417.27 387.838Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M442.624 403L420 398.138L424.376 373L447 377.862L442.624 403Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M436.233 390.89C435.887 393.015 434.314 394.482 431.584 393.853C430.154 393.521 428.786 392.672 428 391.571L429.079 390.011C429.704 390.914 430.73 391.63 431.877 391.897C433.225 392.206 434.133 391.682 434.319 390.541C434.509 389.383 434.002 388.509 431.902 388.026L429.45 387.462L431.042 381L437 382.374L436.692 384.26L432.332 383.253L431.658 386L432.629 386.222C435.628 386.914 436.58 388.748 436.233 390.89Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M489.786 413L468 408.138L472.214 383L494 387.862L489.786 413Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M481.39 392.671L481.121 394.059L474.886 402.968L472.672 402.54L478.686 393.968L474.3 393.121L473.935 395.018L472 394.643L472.709 391L481.39 392.671ZM488.952 402.218C488.586 404.093 486.85 405.443 483.851 404.865C482.271 404.559 480.788 403.777 479.906 402.765L481.11 401.334C481.782 402.154 482.911 402.818 484.168 403.059C485.652 403.343 486.657 402.866 486.856 401.827C487.055 400.825 486.442 400.032 484.754 399.711L483.733 399.513L484.007 398.093L487.125 395.58L482.056 394.6L482.389 392.87L490 394.332L489.731 395.72L486.394 398.409C488.452 399.084 489.274 400.547 488.952 402.218Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.624 422L155 417.138L159.376 392L182 396.862L177.624 422Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.159 410.8L166.837 412.598L159 410.965L159.256 409.546L164.254 406.115C165.476 405.268 165.778 404.636 165.896 404.003C166.085 402.958 165.522 402.211 164.218 401.941C163.185 401.727 162.254 401.925 161.512 402.618L160.335 401.188C161.369 400.165 162.97 399.769 164.714 400.132C167.026 400.61 168.285 402.178 167.922 404.201C167.722 405.312 167.251 406.263 165.512 407.446L162.151 409.761L167.159 410.8ZM175.851 408.545C176.347 405.785 175.574 404.3 174.117 403.998C172.674 403.701 171.441 404.762 170.945 407.523C170.449 410.283 171.221 411.762 172.664 412.065C174.122 412.367 175.354 411.3 175.851 408.545ZM168.955 407.11C169.63 403.354 171.927 401.633 174.449 402.156C176.981 402.684 178.516 405.202 177.841 408.958C177.165 412.713 174.868 414.435 172.331 413.907C169.814 413.384 168.28 410.866 168.955 407.11Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M413.462 424L390 419.138L394.538 394L418 398.862L413.462 424Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M402.223 404.984C401.999 405.96 402.827 406.739 404.43 406.996C406.047 407.259 407.183 406.799 407.413 405.823C407.65 404.798 406.73 404.041 405.173 403.789C403.609 403.537 402.459 403.959 402.223 404.984ZM406.697 410.839C406.953 409.715 405.948 408.827 404.076 408.526C402.203 408.224 400.908 408.739 400.646 409.863C400.383 411.02 401.355 411.886 403.228 412.188C405.101 412.489 406.428 411.996 406.697 410.839ZM409.233 411.316C408.741 413.432 406.237 414.397 402.84 413.849C399.45 413.301 397.59 411.634 398.077 409.518C398.366 408.268 399.364 407.462 400.889 407.155C399.916 406.47 399.502 405.56 399.752 404.485C400.199 402.534 402.531 401.64 405.554 402.134C408.603 402.621 410.383 404.178 409.93 406.13C409.68 407.204 408.872 407.917 407.643 408.241C408.938 409.008 409.523 410.066 409.233 411.316Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M437.624 428L415 423.144L419.376 398L442 402.862L437.624 428Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M428.398 406.906L426.412 418.752L424.5 418.33L426.179 408.331L424 407.847L424.312 406L428.398 406.906ZM434 408.155L432.009 420L430.097 419.572L431.776 409.574L429.602 409.09L429.914 407.248L434 408.155Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M462.3 434L438 428.976L442.7 403L467 408.024L462.3 434Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M454.951 413.693L454.694 415.098L448.753 424.122L446.636 423.688L452.377 415.006L448.189 414.149L447.84 416.064L446 415.69L446.672 412L454.951 413.693ZM460 414.724L457.939 426L455.966 425.598L457.703 416.081L455.448 415.619L455.771 413.861L460 414.724Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M485.624 438L463 433.3L467.376 409L490 413.7L485.624 438Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M480.993 429.007L480.592 431L471 429.191L471.313 427.614L477.428 423.8C478.931 422.859 479.301 422.156 479.439 421.447C479.671 420.286 478.988 419.461 477.384 419.161C476.119 418.923 474.978 419.137 474.07 419.907L472.629 418.318C473.901 417.181 475.855 416.741 477.998 417.15C480.824 417.682 482.365 419.424 481.926 421.673C481.676 422.908 481.099 423.965 478.969 425.273L474.853 427.852L480.993 429.007Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.624 448L151 442.976L155.376 417L178 422.024L173.624 448Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M162.644 426.903L160.542 438.71L158.523 438.29L160.296 428.324L158 427.841L158.329 426L162.644 426.903ZM173 429.08L172.738 430.551L166.677 440L164.517 439.545L170.369 430.455L166.101 429.557L165.746 431.562L163.863 431.17L164.553 427.307L173 429.08Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M409.3 450L385 444.976L389.7 419L414 424.024L409.3 450Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M401.952 428.698L401.696 430.097L395.752 439.123L393.641 438.689L399.375 430.005L395.193 429.148L394.84 431.068L393 430.688L393.676 427L401.952 428.698ZM407 429.728L404.94 441L402.962 440.593L404.699 431.079L402.449 430.618L402.767 428.861L407 429.728Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M432.786 454L411 449.138L415.214 424L437 428.862L432.786 454Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M422.747 441.454C422.399 443.356 420.719 444.722 417.817 444.137C416.288 443.828 414.848 443.037 414 442.012L415.165 440.565C415.81 441.394 416.902 442.066 418.124 442.31C419.559 442.597 420.532 442.11 420.724 441.069C420.912 440.05 420.324 439.247 418.691 438.922L417.703 438.722L417.968 437.285L420.984 434.743L416.075 433.751L416.403 432L423.762 433.485L423.507 434.884L420.277 437.605C422.264 438.288 423.065 439.768 422.747 441.454ZM430.886 438.424C431.084 437.361 430.434 436.364 428.999 436.071C427.745 435.822 426.747 436.385 426.528 437.562C426.31 438.738 427.022 439.649 428.333 439.909C429.628 440.174 430.678 439.535 430.886 438.424ZM432.832 440.95C432.119 444.815 429.56 446.5 426.43 445.872C425.348 445.655 424.36 445.205 423.72 444.576L424.755 443.145C425.27 443.665 425.951 443.953 426.705 444.11C428.744 444.516 430.273 443.459 430.746 440.895L430.751 440.885C429.956 441.54 428.848 441.719 427.646 441.475C425.514 441.047 424.172 439.372 424.563 437.263C424.979 435.03 426.986 433.962 429.196 434.407C432.145 435.003 433.502 437.334 432.832 440.95Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M458.3 459L434 454.462L438.7 431L463 435.538L458.3 459Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M446.291 437.958L444.349 450.395L442.488 449.946L444.126 439.448L442 438.939L442.304 437L446.291 437.958ZM454.241 448.803C453.898 450.987 452.342 452.496 449.641 451.849C448.225 451.508 446.871 450.628 446.093 449.503L447.161 447.899C447.78 448.821 448.795 449.557 449.93 449.832C451.264 450.149 452.163 449.611 452.347 448.438C452.535 447.247 452.033 446.355 449.955 445.858L447.529 445.277L449.104 438.628L455 440.04L454.696 441.98L450.38 440.944L449.713 443.775L450.675 444.003C453.642 444.715 454.584 446.6 454.241 448.803Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M481.467 463L458 458.462L462.538 435L486 439.538L481.467 463Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M471.587 451.322C471.24 453.392 469.592 454.882 466.745 454.244C465.245 453.906 463.837 453.043 463 451.925L464.143 450.346C464.775 451.251 465.852 451.984 467.046 452.25C468.454 452.564 469.408 452.031 469.597 450.896C469.78 449.784 469.204 448.914 467.602 448.553L466.633 448.335L466.893 446.767L469.852 443.993L465.036 442.911L465.357 441L472.581 442.621L472.326 444.147L469.158 447.116C471.112 447.861 471.893 449.476 471.587 451.322ZM480.178 455.066L479.857 457L472.041 455.249L472.296 453.723L477.28 450.032C478.5 449.115 478.801 448.441 478.918 447.755C479.107 446.631 478.546 445.833 477.245 445.537C476.214 445.312 475.28 445.519 474.546 446.264L473.372 444.726C474.403 443.626 476 443.2 477.739 443.591C480.045 444.111 481.301 445.791 480.938 447.974C480.739 449.169 480.27 450.186 478.535 451.458L475.183 453.948L480.178 455.066Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M169.462 474L146 469.138L150.538 444L174 448.862L169.462 474Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M156.955 452.822L154.718 463.487L152.564 463.107L154.455 454.1L152 453.664L152.352 452L156.955 452.822ZM165.655 459.903C166.196 457.325 165.354 455.939 163.763 455.656C162.19 455.379 160.845 456.37 160.304 458.948C159.762 461.525 160.61 462.907 162.184 463.189C163.774 463.472 165.114 462.481 165.655 459.903ZM158.138 458.563C158.875 455.055 161.375 453.448 164.126 453.936C166.894 454.429 168.562 456.781 167.826 460.288C167.089 463.795 164.584 465.402 161.821 464.915C159.07 464.422 157.402 462.07 158.138 458.563Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M458.077 384.818L459.242 389.289L463.404 390.816L459.722 393.364L459.628 398L456.181 395.1L451.961 396.44L453.517 392.101L451 388.295L455.408 388.509L458.077 384.818ZM518.516 306.289C511.287 304.817 504.973 309.095 503.636 316.345C502.304 323.601 506.649 330.043 513.878 331.515C521.106 332.987 527.421 328.741 528.758 321.453C530.1 314.17 525.749 307.755 518.516 306.289Z",
    fill: "#407BFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M182.696 315L184.293 320.771L190 322.735L184.949 326.02L184.827 332L180.104 328.264L174.318 329.992L176.449 324.397L173 319.484L179.041 319.764L182.696 315Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M432.845 306.143C433.298 303.646 431.716 302.167 428.419 301.49L421.351 300.04L420.037 307.257L427.106 308.707C430.403 309.385 432.386 308.64 432.845 306.143ZM423.266 289.541L422.01 296.434L428.198 297.705C431.231 298.326 433.156 297.537 433.573 295.252C433.995 292.929 432.486 291.434 429.458 290.812L423.266 289.541ZM437.165 307.509C436.384 311.798 432.766 313.652 426.71 312.409L415 310.001L419.557 285L430.592 287.262C436.247 288.427 438.811 291.585 438.088 295.549C437.618 298.119 436.062 299.765 434.058 300.426C436.426 301.804 437.756 304.262 437.165 307.509ZM445.161 290.252L449.534 291.154L444.982 316.155L440.604 315.259L445.161 290.252ZM476.821 296.753L472.269 321.759L468.666 321.02L458.765 301.423L455.679 318.355L451.338 317.459L455.89 292.458L459.493 293.197L469.399 312.795L472.48 295.863L476.821 296.753ZM497.008 313.568L501.149 314.419L499.329 324.386C496.491 325.987 492.862 326.357 489.533 325.673C482.233 324.173 477.829 317.672 479.189 310.208C480.55 302.744 486.912 298.455 494.286 299.967C498.221 300.773 501.265 302.845 503 305.981L499.719 308.271C498.226 305.925 496.269 304.598 493.743 304.082C488.732 303.052 484.538 305.936 483.594 311.115C482.671 316.188 485.53 320.623 490.509 321.647C492.192 321.995 493.906 321.978 495.589 321.356L497.008 313.568Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 382,
    y: 274,
    width: 157,
    height: 200
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M382.14 274.855H538.943V473.148H382.14V274.855Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.146 473.148L382.14 446.841L412.942 274.855L538.943 301.162L508.146 473.148Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 382,
    y: 274,
    width: 118,
    height: 173
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M382.14 274.855H499.676V446.841H382.14V274.855Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.676 292.044C499.676 292.044 449.971 410.308 382.14 446.841L412.942 274.855L499.676 292.044Z",
    fill: "black"
  })))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M221 418C221 419.719 220.882 421.405 220.646 423.039C218.452 438.31 206.455 450 191.992 450C175.981 450 163 435.663 163 418C163 400.32 175.981 386 191.992 386C197.206 386 202.087 387.504 206.312 390.168C209.28 392.023 211.915 394.444 214.11 397.294C217.314 401.451 219.57 406.519 220.503 412.095V412.118C220.831 414.035 221 415.987 221 418Z",
    fill: "#407BFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M206.342 407.547C205.84 405.642 204.02 404.561 201.481 405.309C199.268 405.959 198.089 407.738 198.647 409.845C199.201 411.946 201.057 412.83 203.379 412.148C205.675 411.471 206.869 409.534 206.342 407.547ZM211.446 410.019C213.271 416.94 210.458 421.869 204.915 423.507C203.001 424.069 201.057 424.178 199.542 423.692L200.106 420.477C201.336 420.892 202.66 420.783 203.999 420.384C207.604 419.326 209.243 416.291 208.033 411.706L208.023 411.679C207.252 413.431 205.602 414.664 203.472 415.292C199.702 416.4 196.253 414.806 195.25 411.029C194.19 407.023 196.605 403.573 200.514 402.427C205.727 400.888 209.729 403.53 211.446 410.019Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M233.725 135.41C232.859 136.836 232.124 138.294 231.508 139.786C225.736 153.711 230.142 170.442 242.501 178.96C256.178 188.398 274.439 184.194 283.273 169.584C292.117 154.964 288.19 135.477 274.512 126.04C270.059 122.972 265.137 121.341 260.193 121.051C256.731 120.84 253.269 121.285 249.968 122.349C245.155 123.902 240.691 126.758 237.104 130.822L237.088 130.845C235.852 132.231 234.731 133.746 233.725 135.41Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.399994
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 120,
    width: 59,
    height: 64
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M229.244 120.432H287.859V183.725H229.244V120.432Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.937 134.909C233.077 136.341 232.347 137.806 231.736 139.305C226.001 153.295 230.378 170.105 242.656 178.663C256.243 188.144 274.385 183.921 283.16 169.243C291.946 154.554 288.045 134.976 274.457 125.494C270.033 122.412 265.143 120.773 260.232 120.482C256.793 120.27 253.353 120.717 250.074 121.786C245.292 123.346 240.858 126.216 237.294 130.299L237.278 130.322C236.051 131.715 234.937 133.236 233.937 134.909Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 120,
    width: 48,
    height: 52
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M231.046 120.432H278.529V171.089H231.046V120.432Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.937 134.909C233.077 136.341 232.347 137.806 231.735 139.305C229.378 149.631 233.181 160.908 241.899 166.989C252.907 174.669 267.63 171.246 274.737 159.359C281.839 147.489 278.679 131.58 267.676 123.9C265.324 122.261 262.807 121.137 260.232 120.482C256.792 120.27 253.353 120.717 250.074 121.786C255.684 120.482 261.766 121.484 266.956 125.103C277.338 132.347 280.332 147.372 273.623 158.587C266.91 169.808 253 173.03 242.619 165.786C232.238 158.548 229.238 143.534 235.952 132.308C236.367 131.608 236.802 130.959 237.278 130.322C236.051 131.715 234.937 133.236 233.937 134.909Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 124,
    width: 38,
    height: 41
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M235.559 124.191H272.458V164.035H235.559V124.191Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.511 133.303C232.984 142.544 235.44 154.879 243.997 160.847C252.555 166.816 263.978 164.159 269.505 154.918C275.033 145.677 272.572 133.348 264.014 127.38C255.456 121.411 244.039 124.063 238.511 133.303Z",
    fill: "white"
  })))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M262 141.516L260.298 143.409L242.804 151L240 148.06L256.864 140.78L251.318 134.961L248.991 137.546L246.551 134.988L251.036 130L262 141.516Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 124,
    width: 53,
    height: 60
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M229.244 124.594H281.093V183.725H229.244V124.594Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.937 134.909C233.077 136.341 232.347 137.806 231.735 139.305C226.001 153.295 230.378 170.105 242.656 178.663C255.254 187.451 271.758 184.458 281.093 172.281C271.898 177.992 260.129 178.087 250.607 171.441C238.33 162.877 233.953 146.074 239.682 132.084C240.299 130.585 241.034 129.119 241.889 127.687C242.542 126.591 243.251 125.567 244.008 124.594C241.552 126.11 239.288 128.023 237.294 130.299L237.278 130.322C236.051 131.715 234.937 133.236 233.937 134.909Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 133,
    width: 19,
    height: 21
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M265.506 133.219H283.927V153.111H265.506V133.219Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.982 137.773C264.221 142.387 265.449 148.54 269.717 151.516C273.991 154.498 279.69 153.172 282.451 148.563C285.212 143.948 283.984 137.795 279.71 134.813C275.442 131.832 269.738 133.158 266.982 137.773Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 154,
    width: 10,
    height: 10
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M275.913 154.269H284.134V163.146H275.913V154.269Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.571 156.299C275.338 158.358 275.887 161.104 277.793 162.436C279.7 163.761 282.243 163.174 283.476 161.116C284.709 159.057 284.16 156.31 282.254 154.979C280.347 153.648 277.804 154.241 276.571 156.299Z",
    fill: "white"
  })))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M274 528.003C274 553.658 255.186 574.515 231.803 574.989C231.528 575 231.268 575 230.992 575C227.876 575 224.847 574.643 221.92 573.963C214.637 572.247 208.043 568.512 202.637 563.345C200.143 560.932 197.884 558.207 195.951 555.241C195.941 555.225 195.925 555.213 195.925 555.213C190.938 547.522 188 538.13 188 528.003C188 502.046 207.247 481 230.992 481C254.758 481 274 502.046 274 528.003Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 504,
    width: 68,
    height: 72
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M191.619 504.058H258.554V575.697H191.619V504.058Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.079 504.058C206.632 504.058 191.619 520.269 191.619 540.199C191.619 545.799 192.8 551.096 194.909 555.839C194.909 555.839 194.924 555.851 194.935 555.867C196.898 558.843 199.193 561.579 201.726 564.001C196.287 557.797 192.945 549.406 192.945 540.199C192.945 521.052 207.362 505.49 225.079 505.49C242.811 505.49 257.228 521.052 257.228 540.199C257.228 559.33 242.811 574.897 225.079 574.897C223.804 574.897 222.546 574.813 221.313 574.657C224.286 575.339 227.363 575.697 230.528 575.697C230.808 575.697 231.072 575.697 231.352 575.686C246.831 572.509 258.554 557.797 258.554 540.199C258.554 520.269 243.541 504.058 225.079 504.058Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 511,
    width: 56,
    height: 61
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M196.261 511.939H251.255V571.323H196.261V511.939Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.255 541.631C251.255 558.026 238.946 571.323 223.758 571.323C208.569 571.323 196.261 558.026 196.261 541.631C196.261 525.23 208.569 511.939 223.758 511.939C238.946 511.939 251.255 525.23 251.255 541.631Z",
    fill: "white"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M220.76 556.745C220.597 558.126 220.428 559.495 220.264 560.869C214.109 559.96 208.002 558.541 202 556.623C202.127 555.543 202.259 554.462 202.385 553.381C206.012 551.13 209.67 548.725 213.354 546.164C216.057 544.257 216.675 542.783 216.849 541.331C217.134 538.931 215.73 537.273 212.684 536.564C210.277 535.998 208.165 536.303 206.571 537.772C205.611 536.591 204.655 535.394 203.7 534.186C205.906 532.074 209.501 531.498 213.576 532.434C218.966 533.659 222.143 536.985 221.584 541.652C221.278 544.185 220.317 546.452 216.448 549.218C213.961 551.014 211.486 552.738 209.021 554.395C212.906 555.382 216.817 556.169 220.76 556.745ZM245 535.594C244.868 536.691 244.741 537.783 244.609 538.881C240.429 546.752 236.237 554.462 232.057 562C230.389 561.928 228.721 561.817 227.053 561.673C231.091 554.561 235.134 547.3 239.178 539.884C235.873 539.889 232.569 539.756 229.27 539.474C229.095 540.965 228.916 542.456 228.736 543.947C227.29 543.819 225.838 543.67 224.392 543.487C224.735 540.627 225.078 537.761 225.421 534.895C231.925 535.693 238.476 535.926 245 535.594Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 518,
    width: 89,
    height: 58
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M186.859 518.451H274.214V575.697H186.859V518.451Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.214 528.531C274.214 554.279 255.104 575.21 231.352 575.686C231.072 575.697 230.808 575.697 230.528 575.697C227.363 575.697 224.286 575.339 221.313 574.657C213.915 572.934 207.217 569.186 201.726 564.001C199.193 561.578 196.898 558.843 194.935 555.867C194.924 555.85 194.909 555.839 194.909 555.839C189.842 548.12 186.859 538.694 186.859 528.531C186.859 525.079 187.206 521.701 187.853 518.451C188.268 527.742 191.169 536.334 195.852 543.466C195.852 543.466 195.867 543.477 195.877 543.494C197.841 546.47 200.136 549.205 202.669 551.627C208.16 556.813 214.853 560.56 222.256 562.283C225.224 562.971 228.301 563.329 231.471 563.329C231.751 563.329 232.015 563.329 232.295 563.313C252.861 562.899 269.956 547.147 274.162 526.209C274.198 526.97 274.214 527.759 274.214 528.531Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 486,
    width: 27,
    height: 29
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M214.894 486.918H240.34V514.395H214.894V486.918Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.34 500.657C240.34 508.247 234.647 514.395 227.617 514.395C220.593 514.395 214.894 508.247 214.894 500.657C214.894 493.066 220.593 486.918 227.617 486.918C234.647 486.918 240.34 493.066 240.34 500.657Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 243,
    y: 499,
    width: 10,
    height: 10
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M243.412 499.27H252.275V508.846H243.412V499.27Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.275 504.058C252.275 506.698 250.291 508.846 247.841 508.846C245.396 508.846 243.412 506.698 243.412 504.058C243.412 501.412 245.396 499.27 247.841 499.27C250.291 499.27 252.275 501.412 252.275 504.058Z",
    fill: "white"
  })))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M152.552 384.828C152.934 386.076 153.231 387.323 153.459 388.581C156.291 403.994 147.785 419.54 133.196 424.474C117.43 429.808 100.534 420.715 95.4538 404.15C90.3735 387.596 99.0334 369.85 114.799 364.521C118.766 363.179 122.812 362.751 126.726 363.135C129.701 363.402 132.591 364.159 135.312 365.323C141.766 368.079 147.27 373.185 150.616 379.956L150.622 379.973C151.391 381.51 152.032 383.136 152.552 384.828Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 363,
    width: 49,
    height: 52
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M104.968 363.011H152.461V414.177H104.968V363.011Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.69 379.926C149.819 380.318 149.949 380.71 150.068 381.101C153.855 393.805 147.364 407.481 135.599 411.576C123.825 415.676 111.169 408.656 107.377 395.953C103.585 383.249 110.071 369.578 121.846 365.478C126.187 363.967 130.647 363.967 134.734 365.209C132.077 364.04 129.254 363.279 126.347 363.011C124.716 363.19 123.068 363.548 121.437 364.118C108.968 368.454 102.098 382.93 106.113 396.394C110.133 409.859 123.535 417.282 136.004 412.941C146.043 409.45 152.446 399.398 152.461 388.574C152.239 387.31 151.948 386.057 151.575 384.804C151.068 383.104 150.441 381.47 149.69 379.926Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 664,
    height: 717
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -18.2593H663.078V697.742H0V-18.2593Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 368,
    width: 38,
    height: 41
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M111.532 368.168H148.436V408.018H111.532V368.168Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.54 381.98C150.669 392.451 145.338 403.678 135.641 407.051C125.943 410.424 115.552 404.674 112.428 394.202C109.304 383.73 114.629 372.509 124.327 369.131C134.024 365.758 144.416 371.514 147.54 381.98Z",
    fill: "white"
  })))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M135.996 388.835C137.252 392.286 135.676 396.396 130.867 398.735C128.334 399.972 125.564 400.338 123.499 399.672C123.684 398.473 123.849 397.285 123.993 396.102C125.708 396.652 127.881 396.478 129.91 395.491C132.288 394.335 133.354 392.465 132.69 390.612C132.01 388.731 130.409 388.12 126.691 389.936C125.245 390.639 123.803 391.342 122.356 392.046C121.197 388.415 119.735 384.931 118 381.644C121.522 379.921 125.044 378.209 128.566 376.487C129.147 377.392 129.709 378.302 130.249 379.234C127.67 380.488 125.09 381.748 122.516 383.001C123.185 384.446 123.808 385.923 124.374 387.428C124.946 387.15 125.517 386.872 126.094 386.594C131.398 384.004 134.739 385.351 135.996 388.835ZM137.772 372C141.51 377.79 144.291 384.228 146 391.037C144.893 391.577 143.781 392.117 142.674 392.656C141.227 386.91 139.013 381.431 136.109 376.383C134.842 376.999 133.576 377.615 132.304 378.231C131.768 377.304 131.212 376.389 130.625 375.484C133.009 374.322 135.393 373.161 137.772 372Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M490 544.003C490 564.988 475.003 582 456.497 582C437.997 582 423 564.988 423 544.003C423 523.018 437.997 506 456.497 506C475.003 506 490 523.018 490 544.003Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.399994
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 422,
    y: 507,
    width: 69,
    height: 75
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M422.36 507.427H490.538V581.046H422.36V507.427Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.538 544.228C490.538 544.586 490.538 544.927 490.512 545.274C490.005 565.121 474.94 581.046 456.441 581.046C437.621 581.046 422.36 564.561 422.36 544.228C422.36 523.911 437.621 507.427 456.441 507.427C463.59 507.427 470.231 509.804 475.712 513.871C479.463 516.645 482.674 520.214 485.125 524.353C486.347 526.384 487.394 528.577 488.202 530.87C489.714 535.009 490.538 539.518 490.538 544.228Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 437,
    y: 511,
    width: 54,
    height: 58
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M437.45 511.063H490.538V568.857H437.45V511.063Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.202 530.87C489.145 533.717 489.647 536.766 489.647 539.96C489.647 555.114 478.245 567.425 464.212 567.425C450.184 567.425 438.777 555.114 438.777 539.96C438.777 524.812 450.184 512.495 464.212 512.495C472.873 512.495 480.535 517.194 485.125 524.354C482.674 520.214 479.463 516.645 475.712 513.871C472.236 512.064 468.335 511.063 464.212 511.063C449.453 511.063 437.45 524.023 437.45 539.96C437.45 555.897 449.453 568.857 464.212 568.857C477.287 568.857 488.202 558.677 490.512 545.274C490.538 544.927 490.538 544.586 490.538 544.228C490.538 539.518 489.714 535.01 488.202 530.87Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 444,
    y: 516,
    width: 43,
    height: 47
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M444.081 516.377H487V562.721H444.081V516.377Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487 539.546C487 552.345 477.39 562.721 465.538 562.721C453.685 562.721 444.081 552.345 444.081 539.546C444.081 526.748 453.685 516.377 465.538 516.377C477.39 516.377 487 526.748 487 539.546Z",
    fill: "white"
  })))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M480.694 540.08C481.845 544.257 479.816 548.565 473.517 550.35C470.195 551.289 466.563 551.217 463.94 550.095L464.834 546.14C466.939 547.085 469.743 547.284 472.388 546.532C475.507 545.649 476.969 543.737 476.347 541.495C475.72 539.219 473.887 538.202 469.028 539.578L463.362 541.18L461 527.9L474.776 524L475.802 527.701L465.707 530.557L466.721 536.203L468.968 535.567C475.911 533.601 479.532 535.871 480.694 540.08Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 520,
    width: 21,
    height: 22
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M429.416 520.712H449.002V541.862H429.416V520.712Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.002 531.29C449.002 537.13 444.615 541.862 439.207 541.862C433.798 541.862 429.416 537.13 429.416 531.29C429.416 525.45 433.798 520.712 439.207 520.712C444.615 520.712 449.002 525.45 449.002 531.29Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 440,
    y: 543,
    width: 8,
    height: 8
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M440.88 543.288H447.277V550.197H440.88V543.288Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.277 546.74C447.277 548.647 445.848 550.197 444.081 550.197C442.315 550.197 440.88 548.647 440.88 546.74C440.88 544.832 442.315 543.288 444.081 543.288C445.848 543.288 447.277 544.832 447.277 546.74Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 422,
    y: 528,
    width: 69,
    height: 54
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M422.743 528.705H490.538V581.046H422.743V528.705Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.538 544.228C490.538 544.586 490.538 544.927 490.512 545.274C490.004 565.121 474.94 581.046 456.441 581.046C439.362 581.046 425.209 567.47 422.743 549.755C428.152 562.329 439.958 571.039 453.644 571.039C472.143 571.039 487.207 555.113 487.715 535.261C487.735 534.92 487.735 534.579 487.735 534.221C487.735 532.341 487.606 530.512 487.352 528.705C487.658 529.404 487.948 530.137 488.202 530.87C489.714 535.009 490.538 539.518 490.538 544.228Z",
    fill: "black"
  })))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M525 244.003C525 261.667 511.571 276 494.992 276C478.429 276 465 261.667 465 244.003C465 241.022 465.382 238.137 466.098 235.4C466.793 232.707 467.811 230.173 469.126 227.826C473.321 220.185 480.423 214.562 488.813 212.684C490.813 212.232 492.876 212 494.992 212C495.538 212 496.063 212.017 496.594 212.045C512.425 212.928 525 226.904 525 244.003Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 466,
    y: 211,
    width: 49,
    height: 52
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M466.874 211.897H514.378V262.375H466.874V211.897Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.713 211.942C496.195 211.914 495.677 211.897 495.148 211.897C493.082 211.897 491.066 212.127 489.113 212.574C489.621 212.529 490.124 212.513 490.626 212.513C502.986 212.513 513.052 223.37 513.052 236.728C513.052 250.075 502.986 260.943 490.626 260.943C478.256 260.943 468.201 250.075 468.201 236.728C468.201 233.478 468.796 230.385 469.884 227.549C468.599 229.87 467.605 232.376 466.926 235.039C466.89 235.598 466.874 236.157 466.874 236.728C466.874 250.863 477.525 262.375 490.626 262.375C503.717 262.375 514.378 250.863 514.378 236.728C514.378 224.858 506.871 214.851 496.713 211.942Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.800003
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 470,
    y: 215,
    width: 38,
    height: 41
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M470.884 215.673H507.778V255.512H470.884V215.673Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.778 235.592C507.778 246.595 499.521 255.512 489.331 255.512C479.147 255.512 470.884 246.595 470.884 235.592C470.884 224.595 479.147 215.673 489.331 215.673C499.521 215.673 507.778 224.595 507.778 235.592Z",
    fill: "white"
  })))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M491.307 220.903C485.971 226.985 481.89 233.851 479.353 240.964C478.239 240.508 477.119 240.045 476 239.589C478.155 233.586 481.414 227.763 485.594 222.436C484.333 221.918 483.078 221.405 481.822 220.886C482.597 219.905 483.402 218.941 484.234 218C486.593 218.964 488.947 219.933 491.307 220.903ZM501 224.882C495.711 230.993 491.678 237.875 489.198 245C488.079 244.543 486.959 244.081 485.84 243.625C487.948 237.61 491.165 231.771 495.308 226.427L491.537 224.877C492.3 223.896 493.101 222.927 493.927 221.98C496.287 222.949 498.641 223.913 501 224.882Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 466,
    y: 228,
    width: 59,
    height: 48
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M466.092 228.393H524.459V275.196H466.092V228.393Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.459 243.547C524.459 261.016 511.342 275.191 495.149 275.191C480.255 275.191 467.952 263.181 466.092 247.625C471.065 257.464 480.721 264.154 491.833 264.154C508.027 264.154 521.143 249.974 521.143 232.505C521.143 231.117 521.06 229.741 520.889 228.393C523.169 232.891 524.459 238.048 524.459 243.547Z",
    fill: "black"
  })))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M403 473.951L174.432 522L118 211.049L346.568 163L403 473.951Z",
    fill: "#407BFF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M291 377.176L250.006 386L242 340.819L282.994 332L291 377.176Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M284.653 353.767C286.612 364.335 280.073 374.576 270.047 376.635C260.021 378.699 250.305 371.807 248.347 361.238C246.388 350.67 252.927 340.43 262.953 338.365C272.979 336.301 282.695 343.193 284.653 353.767Z",
    fill: "#407BFF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M188 299.667L145.333 308L137 265.333L179.667 257L188 299.667Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M161.952 290.036L162.525 293.668L148.803 297L148.354 294.128L154.375 283.612C155.842 281.028 155.951 279.599 155.748 278.31C155.412 276.193 154.054 275.255 151.767 275.813C149.959 276.249 148.561 277.378 147.786 279.28L145 277.556C146.057 274.794 148.413 272.751 151.471 272.009C155.511 271.027 158.519 272.935 159.161 277.034C159.517 279.28 159.334 281.452 157.225 285.078L153.18 292.165L161.952 290.036ZM177.427 286.281L178 289.913L164.283 293.245L163.829 290.373L169.85 279.857C171.322 277.273 171.426 275.844 171.223 274.555C170.892 272.438 169.529 271.5 167.242 272.058C165.434 272.494 164.041 273.623 163.261 275.525L160.48 273.8C161.537 271.039 163.893 268.996 166.951 268.254C170.991 267.272 173.994 269.18 174.641 273.279C174.992 275.525 174.809 277.697 172.705 281.323L168.655 288.41L177.427 286.281Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M230 292.013L189.006 301L181 254.987L221.994 246L230 292.013Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M198.401 263.511L202.041 284.246L198.579 285L195.507 267.495L191.564 268.348L191 265.123L198.401 263.511ZM217.886 274.346C218.5 277.841 216.66 281.379 211.658 282.469C209.022 283.041 206.227 282.722 204.233 281.588L205.198 278.27C206.746 279.227 208.913 279.585 211.015 279.128C213.493 278.595 214.74 277.059 214.404 275.133C214.077 273.268 212.638 272.321 209.818 272.932L208.111 273.301L207.651 270.665L210.901 264.149L202.432 265.987L201.863 262.757L214.567 260L215.017 262.575L211.544 269.542C215.146 269.284 217.342 271.237 217.886 274.346Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M274 283.176L233.006 292L225 246.824L265.989 238L274 283.176Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M249.989 268.802C250.651 272.721 248.756 276.527 243.6 277.699C240.885 278.315 237.98 277.978 235.953 276.752L236.921 273.194C238.546 274.213 240.772 274.597 242.943 274.106C245.49 273.532 246.779 271.88 246.428 269.779C246.066 267.641 244.665 266.57 240.686 267.476L236.05 268.524L235 256.163L246.27 253.605L246.851 257.074L238.597 258.951L239.055 264.208L240.89 263.788C246.57 262.497 249.327 264.853 249.989 268.802ZM265.875 265.197C266.532 269.116 264.637 272.922 259.486 274.088C256.77 274.71 253.866 274.372 251.838 273.147L252.806 269.589C254.427 270.607 256.658 270.992 258.823 270.501C261.376 269.927 262.66 268.275 262.308 266.173C261.946 264.036 260.545 262.965 256.566 263.87L251.935 264.918L250.881 252.557L262.15 250L262.736 253.475L254.483 255.346L254.936 260.603L256.775 260.182C262.451 258.898 265.212 261.248 265.875 265.197Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M318 273.176L277.006 282L269 236.819L309.994 228L318 273.176Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M293.507 260.727L294.127 264.002L279.152 267L278.656 264.411L285.229 254.935C286.836 252.601 286.95 251.312 286.728 250.151C286.367 248.248 284.879 247.401 282.382 247.899C280.414 248.297 278.888 249.31 278.041 251.03L275 249.47C276.154 246.986 278.726 245.139 282.064 244.47C286.475 243.59 289.754 245.31 290.46 249.006C290.843 251.03 290.643 252.983 288.346 256.258L283.924 262.647L293.507 260.727ZM309.867 254.205C310.563 257.867 308.557 261.419 303.1 262.514C300.226 263.089 297.157 262.779 295.006 261.629L296.03 258.304C297.751 259.256 300.112 259.621 302.404 259.162C305.1 258.62 306.465 257.076 306.093 255.112C305.71 253.116 304.227 252.12 300.015 252.961L295.114 253.945L293.997 242.39L305.925 240L306.546 243.247L297.81 244.995L298.29 249.907L300.236 249.514C306.244 248.314 309.161 250.51 309.867 254.205Z",
    fill: "#263238"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M362 263.177L319.333 272L311 226.823L353.667 218L362 263.177Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M343.104 250.52L339.471 251.273L340.381 256.23L336.687 257L335.777 252.043L324.518 254.382L324 251.574L331.534 235.417L335.609 234.571L328.549 249.981L335.265 248.591L334.454 244.19L338.033 243.449L338.839 247.844L342.478 247.091L343.104 250.52ZM347.991 232L352 253.821L348.187 254.608L344.798 236.187L340.462 237.09L339.836 233.691L347.991 232Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M195 349.013L154.011 358L146 311.987L186.994 303L195 349.013Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M165.688 320.142L169.462 340.268L165.873 341L162.683 324.004L158.591 324.837L158 321.702L165.688 320.142ZM176.22 318L180 338.126L176.405 338.858L173.216 321.867L169.123 322.7L168.538 319.565L176.22 318Z",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M239 338.34L198.006 347L190 302.66L230.994 294L239 338.34Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M216.646 325.639L213.099 326.379L213.987 331.249L210.377 332L209.489 327.13L198.5 329.428L198 326.675L205.353 310.796L209.33 309.965L202.439 325.11L208.99 323.739L208.203 319.421L211.696 318.693L212.483 323.011L216.029 322.266L216.646 325.639ZM231.878 320.832C232.537 324.445 230.559 328.103 225.179 329.224C222.345 329.821 219.346 329.491 217.199 328.319L218.235 324.888C219.905 325.878 222.228 326.248 224.488 325.776C227.151 325.224 228.496 323.637 228.135 321.646C227.779 319.717 226.232 318.738 223.201 319.37L221.372 319.751L220.872 317.026L224.365 310.29L215.263 312.19L214.657 308.85L228.305 306L228.794 308.663L225.057 315.865C228.932 315.598 231.288 317.618 231.878 320.832Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M284 329.013L242.17 338L234 291.987L275.83 283L284 329.013Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M258.025 316.756L254.592 317.487L255.45 322.263L251.965 323L251.107 318.224L240.483 320.478L240 317.777L247.108 302.204L250.953 301.389L244.287 316.243L250.624 314.898L249.863 310.663L253.235 309.949L254.001 314.184L257.429 313.453L258.025 316.756ZM271.08 308.035C270.165 302.957 267.919 301.004 265.262 301.568C262.635 302.126 261.232 304.854 262.142 309.932C263.057 315.004 265.303 316.963 267.929 316.405C270.587 315.841 271.99 313.112 271.08 308.035ZM258.518 310.696C257.275 303.788 260.06 299.146 264.65 298.175C269.271 297.193 273.46 300.357 274.703 307.265C275.947 314.173 273.162 318.821 268.541 319.797C263.951 320.774 259.762 317.604 258.518 310.696Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327 319.498L286.011 328L278 284.496L318.994 276L327 319.498Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M294.267 291.893L297.842 314.189L294.447 315L291.43 296.171L287.559 297.094L287 293.621L294.267 291.893ZM309.122 295.301C308.787 293.201 307.164 291.869 304.731 292.443C302.613 292.946 301.384 294.763 301.758 297.088C302.127 299.414 303.803 300.538 306.028 300.005C308.218 299.485 309.477 297.497 309.122 295.301ZM313.727 298.437C314.951 306.083 311.964 311.16 306.659 312.42C304.828 312.858 302.996 312.799 301.617 312.13L302.37 308.716C303.492 309.272 304.74 309.272 306.023 308.97C309.472 308.148 311.225 305.017 310.414 299.952L310.409 299.923C309.559 301.745 307.932 302.929 305.892 303.414C302.282 304.272 299.159 302.236 298.493 298.065C297.784 293.638 300.286 290.129 304.026 289.242C309.02 288.052 312.576 291.271 313.727 298.437Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M371 311.171L327.496 320L319 274.823L362.504 266L371 311.171Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M341.313 297.969C340.906 295.66 339.089 294.543 336.675 295.066C334.287 295.589 332.919 297.558 333.299 299.738C333.669 301.829 335.433 303.151 338.08 302.576C340.383 302.076 341.719 300.278 341.313 297.969ZM344.862 297C345.634 301.395 342.913 304.879 338.846 305.76C333.416 306.941 329.549 303.739 328.297 296.623C326.966 289.032 330.209 283.997 335.983 282.739C337.974 282.31 339.966 282.369 341.466 283.027L340.647 286.423C339.427 285.865 338.069 285.865 336.675 286.171C332.924 286.987 331.017 290.09 331.9 295.119L331.905 295.149C332.829 293.345 334.599 292.17 336.817 291.688C340.742 290.836 344.139 292.857 344.862 297ZM358.971 289.567C358.031 284.22 355.723 282.163 352.992 282.757C350.292 283.344 348.85 286.218 349.785 291.565C350.726 296.906 353.034 298.968 355.738 298.38C358.469 297.787 359.911 294.914 358.971 289.567ZM346.061 292.369C344.788 285.095 347.646 280.207 352.363 279.184C357.117 278.15 361.417 281.482 362.695 288.756C363.974 296.03 361.111 300.924 356.362 301.953C351.645 302.981 347.34 299.644 346.061 292.369Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M203 394.008L162.007 403L154 356.987L194.993 348L203 394.008Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M175.675 365.927L176.168 368.392L171.778 387.233L167.773 388L172.03 369.858L164.106 371.377L164.775 374.746L161.29 375.413L160 368.933L175.675 365.927ZM194.868 376.491C195.559 379.975 193.567 383.349 188.149 384.39C185.296 384.936 182.244 384.642 180.114 383.549L181.131 380.39C182.839 381.294 185.178 381.641 187.459 381.205C190.136 380.69 191.49 379.223 191.121 377.358C190.741 375.461 189.268 374.509 185.087 375.313L180.215 376.249L179.112 365.27L190.955 363L191.57 366.085L182.892 367.746L183.374 372.412L185.301 372.039C191.271 370.899 194.167 372.985 194.868 376.491Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M248 385.339L206.17 394L198 349.655L239.83 341L248 385.339Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M231.416 373.105L232 376.701L217.908 380L217.441 377.151L223.627 366.744C225.139 364.187 225.251 362.765 225.043 361.49C224.697 359.4 223.302 358.47 220.952 359.017C219.095 359.455 217.659 360.566 216.862 362.449L214 360.748C215.086 358.015 217.507 355.986 220.648 355.251C224.799 354.279 227.889 356.174 228.549 360.232C228.91 362.449 228.722 364.6 226.56 368.196L222.404 375.213L231.416 373.105Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M335 367.177L293.17 376L285 330.823L326.83 322L335 367.177Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M306.682 353.844C306.264 351.507 304.392 350.374 301.912 350.904C299.459 351.429 298.059 353.433 298.45 355.645C298.824 357.762 300.642 359.109 303.355 358.525C305.721 358.018 307.1 356.187 306.682 353.844ZM310.329 352.86C311.121 357.326 308.321 360.856 304.142 361.757C298.563 362.955 294.591 359.705 293.305 352.485C291.937 344.781 295.275 339.671 301.206 338.395C303.247 337.959 305.293 338.019 306.834 338.687L305.993 342.133C304.739 341.567 303.345 341.567 301.912 341.871C298.059 342.7 296.1 345.854 297.006 350.958L297.017 350.988C297.961 349.151 299.779 347.965 302.064 347.47C306.09 346.611 309.58 348.662 310.329 352.86ZM326.875 349.545C327.548 353.331 325.535 357.165 320.043 358.346C317.15 358.966 314.084 358.62 311.897 357.392L312.955 353.796C314.654 354.834 317.031 355.227 319.337 354.727C322.056 354.148 323.429 352.485 323.055 350.398C322.696 348.376 321.117 347.351 318.024 348.012L316.152 348.418L315.647 345.562L319.212 338.496L309.922 340.487L309.303 336.987L323.234 334L323.728 336.791L319.918 344.339C323.869 344.059 326.278 346.176 326.875 349.545Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M379 357.013L337.17 366L329 319.987L370.83 311L379 357.013Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M353.235 347.349L353.851 350.824L339.092 354L338.603 351.258L345.082 341.214C346.666 338.747 346.777 337.382 346.559 336.151C346.203 334.13 344.736 333.239 342.276 333.766C340.331 334.188 338.827 335.26 337.992 337.077L335 335.43C336.137 332.799 338.672 330.842 341.962 330.133C346.31 329.196 349.541 331.024 350.237 334.932C350.614 337.077 350.418 339.151 348.154 342.62L343.796 349.383L353.235 347.349ZM366.946 336.544C366.006 331.211 363.678 329.155 360.93 329.752C358.214 330.332 356.764 333.198 357.704 338.53C358.65 343.863 360.973 345.914 363.694 345.328C366.442 344.742 367.892 341.87 366.946 336.544ZM353.957 339.339C352.677 332.084 355.552 327.203 360.303 326.184C365.081 325.152 369.412 328.481 370.693 335.735C371.979 342.99 369.099 347.865 364.326 348.896C359.575 349.916 355.244 346.593 353.957 339.339Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M213 443.013L170.333 452L162 405.987L204.662 397L213 443.013Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M192.03 427.397C191.639 425.342 189.636 424.411 186.836 424.965C184.029 425.53 182.58 427.148 182.976 429.203C183.378 431.325 185.31 432.234 188.117 431.68C190.923 431.12 192.437 429.514 192.03 427.397ZM181.88 420.013C182.222 421.802 183.899 422.644 186.298 422.168C188.725 421.68 189.995 420.251 189.653 418.462C189.295 416.583 187.509 415.825 185.175 416.29C182.835 416.755 181.521 418.135 181.88 420.013ZM195.884 426.755C196.622 430.633 193.784 433.707 188.703 434.721C183.617 435.729 179.909 433.962 179.171 430.09C178.731 427.791 179.573 425.857 181.489 424.456C179.676 423.857 178.482 422.544 178.107 420.578C177.423 416.999 180.061 414.151 184.594 413.248C189.148 412.34 192.676 413.958 193.36 417.536C193.735 419.509 193.089 421.182 191.596 422.439C193.919 422.999 195.439 424.461 195.884 426.755Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M256 432.177L215.011 441L207 395.823L247.994 387L256 432.177Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M230.833 418.534C231.483 422.143 229.614 425.643 224.513 426.722C221.826 427.289 218.954 426.984 216.948 425.85L217.905 422.573C219.508 423.511 221.716 423.871 223.858 423.418C226.383 422.884 227.653 421.363 227.305 419.428C226.947 417.465 225.561 416.479 221.625 417.307L217.043 418.278L216 406.889L227.149 404.534L227.728 407.734L219.563 409.457L220.012 414.298L221.831 413.916C227.446 412.728 230.178 414.892 230.833 418.534ZM241.942 407.805C241.594 405.87 239.906 404.643 237.38 405.177C235.183 405.641 233.908 407.309 234.296 409.451C234.684 411.594 236.418 412.63 238.726 412.144C241.004 411.659 242.305 409.833 241.942 407.805ZM246.715 410.694C247.99 417.738 244.89 422.415 239.381 423.582C237.481 423.98 235.586 423.925 234.155 423.315L234.936 420.164C236.1 420.682 237.396 420.682 238.721 420.398C242.305 419.64 244.119 416.762 243.277 412.095L243.272 412.068C242.395 413.742 240.702 414.832 238.585 415.279C234.84 416.07 231.604 414.194 230.909 410.351C230.173 406.273 232.774 403.04 236.65 402.223C241.831 401.127 245.525 404.098 246.715 410.694Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M300 423.008L257.333 432L249 385.987L291.667 377L300 423.008Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M275.037 393.923L275.505 396.495L271.299 416.198L267.452 417L271.54 398.029L263.939 399.617L264.581 403.14L261.233 403.838L260 397.062L275.037 393.923ZM284.22 392L288 412.708L284.405 413.461L281.216 395.979L277.123 396.831L276.537 393.61L284.22 392Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M345 413.335L301.496 422L293 377.66L336.504 369L345 413.335Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M317.961 399.79C318.661 403.29 316.643 406.689 311.155 407.73C308.264 408.28 305.173 407.984 303.014 406.89L304.045 403.707C305.775 404.622 308.145 404.965 310.455 404.527C313.167 404.009 314.539 402.539 314.165 400.662C313.78 398.754 312.288 397.797 308.053 398.601L303.123 399.542L302 388.503L313.997 386.219L314.615 389.323L305.829 390.993L306.317 395.688L308.275 395.312C314.317 394.165 317.251 396.264 317.961 399.79ZM334.866 396.57C335.566 400.075 333.549 403.469 328.065 404.511C325.175 405.061 322.083 404.765 319.925 403.67L320.955 400.493C322.68 401.402 325.055 401.746 327.36 401.312C330.077 400.789 331.45 399.319 331.07 397.443C330.69 395.534 329.193 394.577 324.963 395.386L320.028 396.322L318.905 385.284L330.907 383L331.526 386.103L322.739 387.774L323.228 392.468L325.18 392.093C331.222 390.946 334.161 393.044 334.866 396.57Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M388 404.339L346.175 413L338 368.655L379.83 360L388 404.339Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M364.045 374L368 396.199L364.238 397L360.896 378.259L356.618 379.179L356 375.72L364.045 374Z",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M221 488.012L180.006 497L172 450.982L212.994 442L221 488.012Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M188.136 460.511L192.137 481.246L188.332 482L184.951 464.49L180.625 465.348L180 462.118L188.136 460.511ZM209.866 471.126C210.567 474.769 208.551 478.308 203.05 479.392C200.153 479.964 197.055 479.656 194.892 478.517L195.925 475.209C197.653 476.156 200.034 476.514 202.344 476.057C205.067 475.517 206.436 473.988 206.061 472.034C205.681 470.048 204.181 469.052 199.941 469.893L194.995 470.867L193.87 459.377L205.893 457L206.518 460.23L197.713 461.969L198.197 466.856L200.159 466.465C206.214 465.271 209.159 467.456 209.866 471.126Z",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M265 479.34L224.007 488L216 443.66L256.993 435L265 479.34Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M239.2 465.622C239.859 469.109 237.883 472.635 232.509 473.722C229.679 474.293 226.684 473.975 224.538 472.849L225.574 469.538C227.241 470.493 229.562 470.85 231.824 470.394C234.479 469.856 235.823 468.33 235.462 466.408C235.111 464.54 233.566 463.596 230.534 464.211L228.707 464.579L228.208 461.948L231.697 455.446L222.611 457.281L222 454.057L235.637 451.3L236.12 453.876L232.387 460.828C236.258 460.565 238.611 462.514 239.2 465.622ZM255.869 462.102C256.554 465.738 254.579 469.263 249.21 470.35C246.38 470.922 243.353 470.614 241.239 469.472L242.248 466.171C243.937 467.116 246.263 467.478 248.52 467.023C251.18 466.484 252.518 464.952 252.152 463.003C251.775 461.02 250.315 460.032 246.167 460.867L241.34 461.844L240.241 450.372L251.987 448L252.598 451.224L243.995 452.959L244.468 457.835L246.385 457.451C252.301 456.254 255.179 458.434 255.869 462.102Z",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M309 469.504L266.333 478L258 434.496L300.667 426L309 469.504Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M275.093 441.805L279.073 462.256L275.288 463L271.925 445.734L267.622 446.576L267 443.395L275.093 441.805ZM294.503 438L295 440.54L290.567 460.004L286.523 460.796L290.821 442.06L282.819 443.629L283.495 447.102L279.975 447.797L278.673 441.105L294.503 438Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M353 462.013L310.333 471L302 424.987L344.667 416L353 462.013Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M327.119 447.678C327.775 451.14 325.813 454.64 320.463 455.724C317.645 456.291 314.658 455.975 312.527 454.852L313.558 451.565C315.213 452.513 317.529 452.868 319.776 452.415C322.424 451.887 323.762 450.366 323.397 448.457C323.048 446.609 321.51 445.672 318.496 446.277L316.672 446.642L316.181 444.031L319.654 437.576L310.603 439.397L310 436.197L323.572 433.466L324.053 436.017L320.341 442.919C324.19 442.662 326.538 444.592 327.119 447.678ZM344.387 447.247L345 450.475L330.313 453.435L329.832 450.878L336.271 441.539C337.847 439.244 337.963 437.969 337.746 436.824C337.387 434.948 335.933 434.114 333.485 434.605C331.55 434.997 330.054 435.995 329.224 437.685L326.242 436.159C327.373 433.705 329.895 431.885 333.168 431.225C337.492 430.353 340.712 432.054 341.4 435.695C341.78 437.685 341.579 439.615 339.327 442.842L334.997 449.139L344.387 447.247Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M396 469.504L354.17 478L346 434.496L387.83 426L396 469.504Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M373.009 427.849C372.666 425.899 371 424.663 368.508 425.201C366.34 425.668 365.082 427.349 365.465 429.507C365.848 431.666 367.559 432.709 369.836 432.215C372.084 431.732 373.367 429.892 373.009 427.849ZM377.719 430.76C378.977 437.856 375.918 442.568 370.483 443.744C368.613 444.145 366.738 444.09 365.326 443.475L366.096 440.3C367.245 440.822 368.523 440.822 369.831 440.536C373.367 439.773 375.157 436.873 374.327 432.171L374.322 432.144C373.457 433.83 371.786 434.928 369.697 435.379C366.007 436.175 362.809 434.286 362.123 430.413C361.397 426.305 363.963 423.048 367.787 422.224C372.905 421.12 376.545 424.114 377.719 430.76Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M262.975 344.69L267.986 351.486L276.246 351.073L271.542 358.103L274.476 366.099L266.557 363.644L260.11 369L259.921 360.452L253 355.771L260.806 352.937L262.975 344.69ZM315.605 166.545C302.059 169.285 293.935 181.18 296.46 194.548C298.984 207.917 310.836 215.778 324.388 213.039C337.939 210.305 346.074 198.471 343.539 185.036C340.998 171.606 329.157 163.806 315.605 166.545Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M316.584 173L322.408 182.231L332 181.666L326.537 191.209L329.945 202.058L320.742 198.728L313.253 206L313.034 194.398L305 188.038L314.062 184.196L316.584 173Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.100006
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 162,
    width: 209,
    height: 357
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M194.386 162.185H402.955V518.223H194.386V162.185Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.51 162.185C346.51 162.185 352.369 431.078 194.386 518.217L402.955 474.233L346.51 162.185Z",
    fill: "black"
  })))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M414.877 189.01C409.843 189.227 402.161 190.3 397.058 203.609C394.073 211.399 377.949 217.186 375.09 210.48C375.09 210.48 374.411 217.757 376.785 221.312C379.16 224.868 384.226 224.388 384.226 224.388C384.226 224.388 378.139 226.888 376.785 225.735C376.785 225.735 376.996 231.277 382.077 234.433C387.159 237.583 396.626 232.447 396.626 232.447C396.626 232.447 388.228 240.762 384.494 240.762C384.494 240.762 393.883 239.541 399.012 235.317C399.012 235.317 392.735 243.838 389.549 244.608C389.549 244.608 408.506 257.991 423.997 256.941C439.489 255.897 446.618 251.451 446.618 251.451C446.618 251.451 438.314 242.56 436.466 235.734C436.466 235.734 442.916 245.042 450.236 248.249C450.236 248.249 442.221 239.369 439.489 234.433C439.489 234.433 447.419 241.39 454.617 243.678C454.617 243.678 461.388 239.598 464 228.041C464 228.041 447.95 225.016 444.754 218.151C441.553 211.285 444.607 199.1 434.27 193.924C426.772 190.169 418.126 188.868 414.877 189.01Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M379.339 253C378.29 251.381 377.438 249.981 376.582 248.439C375.725 246.935 374.909 245.414 374.103 243.883C372.506 240.82 371.046 237.675 369.672 234.48C366.975 228.064 364.649 221.411 363.072 214.424L362.768 213.112L362.621 212.459L362.464 211.641C362.352 211.065 362.271 210.516 362.215 209.983C362.144 209.434 362.099 208.908 362.068 208.397C361.942 206.322 362.007 204.385 362.134 202.507C362.403 198.758 363.026 195.24 363.746 191.799C365.252 184.915 367.29 178.433 369.86 172L375.994 174.086C374.98 180.541 374.057 187.155 373.51 193.539C373.221 196.733 373.089 199.906 373.145 202.886C373.18 204.368 373.297 205.801 373.489 207.074C373.53 207.398 373.581 207.705 373.646 207.985C373.702 208.287 373.768 208.562 373.844 208.803L373.951 209.209L374.468 210.889C375.355 213.869 376.44 216.817 377.56 219.754C378.731 222.668 379.958 225.572 381.291 228.432C382.629 231.291 384.033 234.118 385.488 236.912C386.218 238.312 386.964 239.695 387.734 241.056C388.489 242.39 389.306 243.828 390 244.992L379.339 253Z",
    fill: "#FFB573"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M396 247.927C388.709 242.929 382.127 229 382.127 229L368 239.352C368 239.352 375.381 255.388 377.285 265.929C378.439 272.332 396 247.927 396 247.927Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.399994
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 367,
    y: 228,
    width: 30,
    height: 40
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M367.148 228.606H396.174V267.935H367.148V228.606Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.174 248.195C396.174 248.195 389.636 257.257 384.135 263.102C380.462 267.012 377.24 269.491 376.763 266.822C376.416 264.937 375.914 262.856 375.287 260.736C372.37 250.645 367.148 239.318 367.148 239.318L381.788 228.606C381.788 228.606 388.616 243.026 396.174 248.195Z",
    fill: "white"
  })))), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M396 588L384.829 587.66L381 560L392.171 560.34L396 588Z",
    fill: "#FFB573"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M383.718 587.001L396.019 587.362C396.468 587.378 396.819 587.701 396.871 588.147L397.989 598.072C398.109 599.101 397.211 600.046 396.181 599.998C391.896 599.797 389.837 599.483 384.428 599.324C381.1 599.223 371.531 599.298 366.938 599.165C362.439 599.032 362.224 594.404 364.153 594.044C372.785 592.42 378.91 590.015 381.868 587.632C382.401 587.202 383.064 586.985 383.718 587.001Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 380,
    y: 559,
    width: 14,
    height: 16
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M380.97 559.946H393.739V574.345H380.97V559.946Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.97 559.946L382.881 574.003L393.744 574.345L391.827 560.282L380.97 559.946Z",
    fill: "black"
  })))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M386.906 250.483C386.906 250.483 372.766 271.632 374.087 322.087C390.972 325.852 408.418 326.17 416.636 328C419.452 308.904 421.477 297.177 437 260.157C437 260.157 428.609 256.095 419.544 253.568C412.458 251.599 406.638 250.037 400.226 249.267C391.773 248.246 386.906 250.483 386.906 250.483Z",
    fill: "#FFB573"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M423 229C420.339 235.581 416.548 247.87 420.301 253.416C420.301 253.416 417.105 259.991 404.735 257.392C391.131 254.541 399.611 249.079 399.611 249.079C407.396 248.809 408.325 243.101 408.09 237.499L423 229Z",
    fill: "#FFB573"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M420.333 253.249C412.814 251.359 406.647 249.873 399.848 249.144C399.393 249.096 398.939 249.048 398.49 249C396.218 251.726 394.833 256.332 397.327 264C397.327 264 416.774 260.486 423 253.963C422.124 253.712 421.231 253.473 420.333 253.249Z",
    fill: "#FFB573"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 407,
    y: 232,
    width: 10,
    height: 9
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M407.803 232.052H416.299V240.951H407.803V232.052Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.273 232.052L407.907 237.052C407.964 238.367 407.954 239.693 407.803 240.946C410.57 241.113 414.864 238.742 415.724 235.766C416.154 234.278 416.372 232.807 416.273 232.052Z",
    fill: "black"
  })))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M373.086 323C373.086 323 362.243 413.058 362.002 448.838C361.757 486.051 380.692 571.547 380.692 571.547L395.202 572C395.202 572 386.382 489.006 388.631 452.515C391.079 412.739 405 324.002 405 324.002L373.086 323Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 361,
    y: 322,
    width: 45,
    height: 250
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M361.689 322.81H405.177V571.677H361.689V322.81Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.899 322.81C372.899 322.81 361.932 412.819 361.689 448.58C361.44 485.773 380.591 571.224 380.591 571.224L395.267 571.677C395.267 571.677 386.347 488.727 388.621 452.255C391.097 412.501 405.177 323.811 405.177 323.811L372.899 322.81Z",
    fill: "white"
  })))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M396.036 572L379.086 571.433L378 565.136L397 565L396.036 572Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 340,
    width: 16,
    height: 89
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M385.197 340.419H400.618V428.292H385.197V340.419Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.315 345.862C379.861 369.043 387.368 412.21 390.771 428.292C393.377 404.379 397.464 375.185 400.619 353.744C399.303 341.516 396.594 335.173 391.315 345.862Z",
    fill: "black"
  })))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M493 485.946L489.023 497L464 491.054L467.977 480L493 485.946Z",
    fill: "#FFB573"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M150.014 500.157L151.154 486.84C151.194 486.356 151.523 485.953 151.946 485.868L161.308 484.026C162.277 483.833 163.103 484.742 162.99 485.862C162.522 490.506 162.095 492.757 161.593 498.611C161.283 502.215 160.723 512.554 160.3 517.527C159.882 522.398 155.54 522.921 155.324 520.863C154.37 511.633 152.516 505.164 150.481 502.118C150.112 501.567 149.95 500.867 150.014 500.157Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 464,
    y: 479,
    width: 17,
    height: 15
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M464.093 479.793H480.866V493.75H464.093V479.793Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.093 490.718L476.909 493.75L480.866 482.825L468.045 479.793L464.093 490.718Z",
    fill: "black"
  })))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M385 323C385 323 394.715 417.277 402.075 452.865C409.729 489.88 474.057 495 474.057 495L481 480.854C481 480.854 443.683 468.991 428.095 444.307C422.138 404.512 417.847 324.015 417.847 324.015L385 323Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 323,
    width: 95,
    height: 171
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M385.093 323.185H479.432V493.828H385.093V323.185Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.093 323.185C385.093 323.185 394.64 416.718 401.872 452.026C409.394 488.749 472.609 493.828 472.609 493.828L479.432 479.793C479.432 479.793 442.76 468.024 427.442 443.535C421.588 404.054 417.372 324.192 417.372 324.192L385.093 323.185Z",
    fill: "white"
  })))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M481 479.281L474.345 496L468 495.887L474.734 477L481 479.281Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M151.251 502.944C151.469 505.069 151.101 506.657 150.227 507.258C149.926 507.466 149.557 507.563 149.1 507.544C148.922 507.535 148.813 507.493 148.751 507.401C148.676 507.299 148.663 507.152 148.69 506.976C148.82 506.066 150.11 504.288 151.251 502.944ZM151.852 502.178C151.838 502.081 151.736 502.011 151.592 502.002C151.449 501.988 151.306 502.039 151.224 502.132C150.821 502.57 147.324 506.468 148.116 507.632C148.273 507.854 148.567 507.983 148.97 507.997C149.646 508.024 150.227 507.877 150.691 507.553C151.428 507.045 151.784 506.159 151.92 505.198C152.077 504.136 151.975 502.991 151.852 502.178Z",
    fill: "#407BFF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M482.721 499.242C483.567 498.251 485.368 497.801 486.241 497.632C485.306 499.084 483.271 501.025 482.539 500.918C482.477 500.913 482.29 500.885 482.29 500.378C482.29 500.322 482.29 500.266 482.295 500.209C482.331 499.861 482.471 499.54 482.721 499.242ZM486.968 497.109C486.921 497.03 486.838 496.991 486.744 497.002C486.62 497.013 483.64 497.385 482.357 498.898C481.963 499.36 481.765 499.883 481.765 500.451C481.771 501.222 482.118 501.431 482.404 501.47C483.629 501.65 486.246 498.803 486.962 497.385C486.983 497.345 486.994 497.306 486.999 497.272C487.004 497.21 486.994 497.159 486.968 497.109ZM381.652 587.252C379.228 587.612 377.442 587.449 376.798 586.785C376.575 586.548 376.486 586.256 376.528 585.879C376.544 585.732 376.596 585.642 376.705 585.581C376.824 585.513 376.99 585.491 377.187 585.496C378.215 585.53 380.178 586.43 381.652 587.252ZM382.499 587.68C382.608 587.657 382.691 587.567 382.706 587.454C382.727 587.336 382.675 587.218 382.576 587.162C382.099 586.869 377.826 584.337 376.471 585.085C376.206 585.232 376.05 585.479 376.014 585.811C375.952 586.368 376.097 586.83 376.445 587.184C376.99 587.747 377.982 587.961 379.062 587.995C380.261 588.034 381.569 587.848 382.499 587.68Z",
    fill: "#407BFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M381.798 583.552C382.689 584.381 383.008 586.292 383.114 587.216C381.787 586.308 380.064 584.264 380.207 583.468C380.223 583.401 380.26 583.199 380.737 583.166C380.79 583.16 380.843 583.16 380.896 583.16C381.231 583.172 381.528 583.3 381.798 583.552ZM383.57 587.95C383.649 587.899 383.692 587.804 383.687 587.703C383.681 587.574 383.506 584.404 382.143 583.132C381.729 582.746 381.241 582.567 380.7 582.611C379.968 582.667 379.751 583.048 379.692 583.362C379.448 584.684 382 587.3 383.31 587.972C383.342 587.989 383.379 588 383.416 588C383.469 588 383.522 587.983 383.57 587.95ZM419.402 321.754L419.98 325.877C420.097 326.196 419.678 326.51 419.158 326.493L372.701 325.081C372.298 325.07 371.985 324.857 372.001 324.6L372.165 320.499C372.176 320.214 372.563 319.984 373.008 320.001L418.713 321.39C419.052 321.396 419.328 321.547 419.402 321.754Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.699997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 371,
    y: 319,
    width: 48,
    height: 8
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M371.977 319.818H418.858V326.301H371.977V319.818Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.273 321.568L418.837 325.685C418.951 326.004 418.542 326.318 418.034 326.301L372.665 324.891C372.272 324.88 371.966 324.667 371.981 324.41L372.142 320.315C372.152 320.03 372.531 319.801 372.966 319.818L417.599 321.205C417.931 321.21 418.2 321.361 418.273 321.568Z",
    fill: "white"
  })))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M414.381 325.96L415.452 326C415.666 326.005 415.842 325.881 415.847 325.722L416 320.334C416.005 320.181 415.833 320.046 415.619 320.034L414.548 320C414.334 319.995 414.158 320.114 414.153 320.272L414 325.66C413.995 325.819 414.167 325.954 414.381 325.96Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 414,
    y: 320,
    width: 3,
    height: 7
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M414.196 320.651H416.429V326.575H414.196V320.651Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.621 326.536L415.817 326.575C416.056 326.581 416.253 326.457 416.258 326.301L416.429 320.981C416.434 320.83 416.242 320.696 416.004 320.685L414.807 320.651C414.569 320.646 414.372 320.763 414.367 320.92L414.196 326.239C414.191 326.396 414.382 326.53 414.621 326.536Z",
    fill: "white"
  })))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M378.565 306.96L380.177 307C380.498 307.005 380.77 306.881 380.777 306.722L381 301.34C381.007 301.181 380.749 301.046 380.428 301.04L378.816 301C378.502 300.995 378.23 301.114 378.223 301.272L378 306.66C377.993 306.819 378.251 306.954 378.565 306.96Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -29,
    width: 664,
    height: 717
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -29H663.078V687.001H0V-29Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 292,
    width: 3,
    height: 7
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3948 292.692H48.6223V298.616H46.3948V292.692Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8144 298.577L48.011 298.616C48.2493 298.621 48.4514 298.498 48.4565 298.342L48.6223 293.028C48.6275 292.871 48.4358 292.737 48.1975 292.731L47.0009 292.692C46.7678 292.686 46.5657 292.804 46.5606 292.96L46.3948 298.28C46.3896 298.437 46.5813 298.571 46.8144 298.577Z",
    fill: "white"
  })))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M396.381 325.96L397.456 326C397.67 326.005 397.846 325.881 397.851 325.728L398 320.334C398.005 320.181 397.832 320.046 397.623 320.034L396.549 320C396.335 319.995 396.154 320.114 396.149 320.272L396 325.66C395.995 325.819 396.168 325.954 396.381 325.96Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.199997
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 320,
    width: 3,
    height: 7
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M396.396 320.097H398.624V326.021H396.396V320.097Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.821 325.982L398.018 326.021C398.256 326.027 398.453 325.904 398.458 325.753L398.624 320.427C398.629 320.276 398.437 320.142 398.204 320.131L397.008 320.097C396.769 320.092 396.567 320.209 396.562 320.366L396.396 325.685C396.391 325.842 396.583 325.976 396.821 325.982Z",
    fill: "white"
  })))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M470.963 263.81L476 253L464.304 256.293C464.304 256.293 462.763 263.121 466.621 266L470.963 263.81Z",
    fill: "#FFB573"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M473.55 243.819L464.729 247.345L465.283 257L476 253.411L473.55 243.819ZM431.144 218.867C426.565 229.531 424.837 234.153 417.661 237.623C406.859 242.837 395.625 234.48 397.137 222.568C398.502 211.841 405.763 196.205 417.318 196.002C428.705 195.805 435.723 208.208 431.144 218.867Z",
    fill: "#FFB573"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M428.532 207.203C424.225 209.53 423.742 221.414 427.719 226C435.297 225.706 441.394 200.249 428.532 207.203Z",
    fill: "#263238"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M407 213C407 213 404.211 216.62 402 217.967C402.699 219.698 404.736 220 404.736 220L407 213Z",
    fill: "#ED893E"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M431.007 229.266C429.582 231.017 427.536 231.897 425.76 231.994C423.092 232.14 422.344 229.412 423.578 227.03C424.687 224.885 427.415 222.228 429.858 223.211C432.265 224.178 432.637 227.262 431.007 229.266Z",
    fill: "#FFB573"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M419.328 214.512C419.1 214.461 418.922 214.271 418.9 214.026C418.649 211.473 415.798 209.82 415.764 209.809C415.502 209.652 415.408 209.317 415.558 209.049C415.708 208.781 416.043 208.686 416.31 208.842C416.449 208.921 419.69 210.797 419.997 213.919C420.03 214.221 419.807 214.495 419.501 214.523C419.445 214.528 419.384 214.523 419.328 214.512ZM403.434 205.38C403.25 205.34 403.094 205.206 403.028 205.011C402.933 204.72 403.089 204.408 403.379 204.313C406.28 203.346 408.296 204.922 408.38 204.989C408.619 205.178 408.658 205.53 408.469 205.765C408.279 206.005 407.934 206.044 407.695 205.86C407.628 205.804 406.046 204.592 403.729 205.363C403.629 205.396 403.529 205.402 403.434 205.38ZM403.34 222.973C403.924 224.738 404.336 227.961 404.336 227.961C404.637 227.978 404.932 227.995 405.233 227.995C409.282 228.095 411.192 226.799 412.083 225.336C412.568 224.532 412.74 223.666 412.785 222.957C412.846 222.136 412.707 221.538 412.707 221.538C410.529 222.772 406.742 222.968 404.721 222.99C403.874 223.007 403.34 222.973 403.34 222.973Z",
    fill: "#263238"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M405 222.486L405.289 223.99C408.59 224.076 410.93 223.611 411.987 222.452C412.04 221.614 411.919 221 411.919 221C410.032 222.263 406.751 222.463 405 222.486Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M405 227.991C409.137 228.15 411.089 226.201 412 224C410.589 224.025 408.893 224.294 407.385 225.168C406.229 225.84 405.495 226.907 405 227.991Z",
    fill: "#DE5753"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M411.922 214.071L410.786 213.084C410.786 213.084 411.121 214.824 412.137 214.728L412.152 214.746C414.172 214.166 414.832 216.336 414.832 216.336C414.743 213.234 412.655 213.784 411.922 214.071ZM403.136 210.251L402 209.264C402 209.264 402.335 211.01 403.35 210.914L403.361 210.932C405.381 210.352 406.045 212.522 406.045 212.522C405.951 209.42 403.863 209.964 403.136 210.251ZM425.523 217C425.523 217 421.724 209.306 424.55 202.24C424.55 202.24 422.247 204.763 421.766 210.317C421.766 210.317 419.479 207.184 416.763 205.169C416.763 205.169 417.276 200.423 418.882 197.703C418.882 197.703 416.177 199.628 415.538 204.787C415.538 204.787 415.062 200.931 416.763 197.703C416.763 197.703 413.775 200.07 413.157 203.729L409.389 202.342C409.389 202.342 410.059 198.384 411.749 197.213C411.749 197.213 409.07 199.06 407.458 201.433C407.458 201.433 403.983 201.331 403.225 202.545C403.225 202.545 404.711 196.991 410.792 194.774C410.792 194.774 405.559 195.479 402.466 198.606C402.466 198.606 406.794 189.525 419.693 192.657C432.588 195.784 435.592 206.06 435.989 210.406C436.387 214.752 425.523 217 425.523 217Z",
    fill: "#263238"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M396.952 246.94C396.952 246.94 393.321 255.512 399.004 257.865C407.504 261.39 421.353 251.364 421.353 251.364C421.353 251.364 433.093 255.523 436.476 258.54C439.865 261.551 425.965 286.027 418.864 316C418.864 316 379.262 304.601 368 300.898C368 300.898 375.472 259.498 384.749 246.23C387.67 242.054 390.406 241.558 396.952 246.94Z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 664,
    height: 717
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H663.078V716.001H0V0Z",
    fill: "black",
    fillOpacity: 0.399994
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 368,
    y: 244,
    width: 70,
    height: 72
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M368.221 244.419H437.735V315.214H368.221V244.419Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.539 276.919C430.814 281.243 428.825 286.199 426.825 291.642C424.184 298.802 421.531 306.779 419.464 315.214C419.464 315.214 379.56 304.155 368.221 300.564C368.221 300.564 375.753 260.423 385.088 247.552C388.035 243.496 390.791 243.026 397.381 248.24C397.381 248.24 393.723 256.541 399.453 258.834C408.021 262.258 421.972 252.536 421.972 252.536C421.972 252.536 433.798 256.569 437.207 259.494C438.88 260.926 436.373 267.343 432.539 276.919Z",
    fill: "white"
  })))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M378.015 155.122L382.816 146.786L371.067 148.386C371.067 148.386 368.374 155.344 371.545 159L372.674 158.812C374.922 158.446 376.88 157.089 378.015 155.122ZM383 138.155L373.058 138L371.067 148.386L382.816 146.786L383 138.155Z",
    fill: "#FFB573"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M439.763 261.18C440.337 262.39 441.12 263.917 441.827 265.293C442.564 266.699 443.332 268.093 444.131 269.459C445.719 272.189 447.383 274.857 449.15 277.368C452.668 282.369 456.647 286.886 460.913 289.616L461.712 290.106L461.763 290.135L461.609 290.06C461.487 290.008 461.359 289.956 461.231 289.922C461 289.864 460.616 289.754 460.304 289.749C459.981 289.731 459.607 289.731 459.274 289.812C458.952 289.864 458.639 289.962 458.363 290.094C457.308 290.59 457.042 291.091 456.944 291.2C456.857 291.333 456.903 291.339 456.985 291.195C457.359 290.653 457.917 289.196 458.342 287.802C459.208 284.886 459.981 281.603 460.642 278.302C461.988 271.682 463.177 264.798 464.37 258L470.853 258.484C471.124 265.691 471.032 272.788 470.474 280.041C470.151 283.671 469.803 287.306 469.004 291.166C468.805 292.134 468.574 293.125 468.282 294.167C467.975 295.222 467.647 296.299 467.048 297.595C466.751 298.223 466.357 298.955 465.768 299.761C465.174 300.539 464.298 301.634 462.516 302.452C462.05 302.648 461.548 302.809 461.041 302.901C460.508 302.982 459.945 303.028 459.423 302.982C458.921 302.936 458.337 302.838 457.927 302.688C457.707 302.613 457.487 302.532 457.267 302.44L456.893 302.273L455.582 301.622C452.125 299.83 449.109 297.486 446.41 294.922C443.706 292.37 441.31 289.576 439.108 286.672C436.9 283.763 434.908 280.727 433.07 277.593C432.158 276.02 431.283 274.43 430.443 272.811C429.577 271.152 428.83 269.62 428 267.696L439.763 261.18Z",
    fill: "#FFB573"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M436.215 258.191C440.712 259.758 449 273.01 449 273.01L435.661 292C435.661 292 424.792 281.656 425.003 274.75C425.225 267.564 431.084 256.404 436.215 258.191Z",
    fill: "#407BFF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M396.844 267L398.655 275.53L406 278.702L399.262 283.253L398.814 292L392.837 286.283L385.214 288.513L388.259 280.429L384 273.06L391.855 273.786L396.844 267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6981,
    fill: "white",
    transform: "translate(-173 -4219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworksImage);
export default __webpack_public_path__ + "static/media/howitworks-Image.d649d6aac17895a479121217291e50e3.svg";
export { ForwardRef as ReactComponent };